var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-field" },
    [
      _vm.fieldLabel
        ? _c("label", { staticClass: "emphasis project-field__label" }, [
            _vm._v("\n    " + _vm._s(_vm.fieldLabel) + ":\n  "),
          ])
        : _vm._t("label"),
      _vm._v(" "),
      _c("div", { staticClass: "field__column" }, [
        _vm.editingFlag
          ? _c(
              "div",
              { ref: "fieldRef", staticClass: "field__edit" },
              [_vm._t("default")],
              2
            )
          : _c(
              "div",
              { staticClass: "field__display" },
              [
                _vm.displayValue
                  ? _c(
                      "span",
                      {
                        staticClass: "field__display-text",
                        on: { dblclick: _vm.doubleClick },
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(_vm.displayValue) + "\n      "
                        ),
                      ]
                    )
                  : _vm._t("display-show"),
                _vm._v(" "),
                _vm.isEditable
                  ? _c("i", {
                      staticClass: "fa fa-pencil icon pointer",
                      on: { click: _vm.editingAction },
                    })
                  : _vm._e(),
              ],
              2
            ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }